import css from 'styled-jsx/css'

const imageStyles = css.global`
  .motor-pc-image {
    position: relative;
    display: inline-block;
    max-width: 100%;
  }
  .motor-pc-image-holder img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .motor-pc-image-auto img {
    max-width: 100%;
  }
  .motor-pc-image-fade {
    opacity: 0;
    transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
      transform 0.3s ease-in-out;
  }
  .motor-pc-image-in {
    opacity: 1;
  }

  .motor-pc-image-hover {
    transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
      transform 0.3s ease-in-out;
  }
  .motor-pc-image-hover:hover {
    transform: scale(1.1);
  }
`
export default imageStyles
